var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.169 39.95",
    fill: "currentColor",
    enableBackground: "new 0 0 35.169 39.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.865,40c-0.694-0.32-0.879-0.872-0.864-1.612C0.139,31.21,5.613,24.83,12.68,23.673 c0.882-0.144,1.784-0.205,2.678-0.225c1.587-0.035,3.177-0.057,4.763,0.001c6.022,0.222,10.431,3.079,13.316,8.316 c1.135,2.061,1.629,4.313,1.728,6.661c0.031,0.732-0.19,1.26-0.863,1.574C23.157,40,12.011,40,0.865,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.443,0c0.798,0.172,1.616,0.28,2.39,0.528c4.589,1.473,7.654,5.996,7.28,10.687 c-0.398,4.995-3.987,8.947-8.84,9.735c-5.992,0.973-11.559-3.3-12.176-9.347C6.511,5.861,10.702,0.678,16.424,0.068 C16.525,0.057,16.624,0.023,16.725,0C17.298,0,17.87,0,18.443,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.db26793b963c2b6878723b9df58193b7.svg";
export { ForwardRef as ReactComponent };